
import { Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import React from "react";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";

export class StatusTone extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Orange", "Teal", "Grey"];
    }
}

export function StatusTone_$reflection() {
    return union_type("Components.StatusCard.StatusTone", [], StatusTone, () => [[], [], []]);
}

function toneColors(tone) {
    switch (tone.tag) {
        case 1:
            return {
                Background: "#E8F8F4",
                Border: "#B5E8DD",
                Dot: "#15BFA0",
            };
        case 2:
            return {
                Background: "#F2F2F2",
                Border: "#DDDDDD",
                Dot: "#8A8A8A",
            };
        default:
            return {
                Background: "#FFF7EA",
                Border: "#F6DDB0",
                Dot: "#F5A623",
            };
    }
}

export function statusDotColor(tone) {
    return toneColors(tone).Dot;
}

export function StatusCard(props) {
    let elems;
    const colors = toneColors(props.Tone);
    return reactElement("div", createObj(ofArray([["data-test-id", props.TestId], ["className", join(" ", ["flex", "items-center", "gap-[10px]", "px-[14px]", "py-3", "rounded-lg", "border", "text-[15px]", "font-bold"])], ["style", {
        backgroundColor: colors.Background,
        borderColor: colors.Border,
    }], (elems = [reactElement("span", {
        className: join(" ", ["w-[10px]", "h-[10px]", "rounded-full", "shrink-0"]),
        style: {
            backgroundColor: colors.Dot,
        },
    }), props.Label], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function StatusActionButton(props) {
    return reactElement("button", {
        "data-test-id": props.TestId,
        type: "button",
        disabled: props.ComponentState === "disabled",
        onClick: (_arg) => {
            props.OnClick();
        },
        className: join(" ", toList(delay(() => append(singleton("px-[14px]"), delay(() => append(singleton("py-[10px]"), delay(() => append(singleton("rounded-[7px]"), delay(() => append(singleton("text-[14px]"), delay(() => append(singleton("font-semibold"), delay(() => append(singleton("border"), delay(() => append(singleton("cursor-pointer"), delay(() => append(singleton("disabled:opacity-50"), delay(() => append(singleton("disabled:cursor-not-allowed"), delay(() => (props.IsPrimary ? append(singleton("bg-primary"), delay(() => append(singleton("text-white"), delay(() => singleton("border-primary"))))) : append(singleton("bg-white"), delay(() => append(singleton("text-[#111111]"), delay(() => append(singleton("border-[#D6D6D6]"), delay(() => singleton("hover:bg-[#F4F4F4]"))))))))))))))))))))))))))))),
        children: props.Label,
    });
}

